/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DataGrid = _interopRequireDefault(require("../components/DataGrid/DataGrid"));
var _withSetState = _interopRequireDefault(require("../hocs/withSetState"));
var _withReduxState = _interopRequireDefault(require("../hocs/withReduxState"));
var _excluded = ["stateType"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var DataGridWithRedux = (0, _withReduxState["default"])(_DataGrid["default"]);
var DataGridWithState = (0, _withSetState["default"])(_DataGrid["default"]);
var DataGridComp = function DataGridComp(_ref) {
  var stateType = _ref.stateType,
    rest = _objectWithoutProperties(_ref, _excluded);
  var Component = stateType === 'redux' ? DataGridWithRedux : DataGridWithState;
  return /*#__PURE__*/_react["default"].createElement(Component, rest);
};
DataGridComp.propTypes = {
  stateType: _propTypes["default"].string
};
var _default = DataGridComp;
exports["default"] = _default;